import { render } from "./SuggestedBlogPost.vue?vue&type=template&id=39e11032&scoped=true"
import script from "./SuggestedBlogPost.vue?vue&type=script&lang=js"
export * from "./SuggestedBlogPost.vue?vue&type=script&lang=js"

import "./SuggestedBlogPost.vue?vue&type=style&index=0&id=39e11032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e11032"]])

export default __exports__